<template>
  <div>
    <b-row align-h="center">
      <b-col sm="12" md="6" lg="4" class="text-center">
        <Auth source="cws" :service="service" />
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col sm="12" md="12" lg="10" v-if="isAuthInCurrentRegion">
        <b-alert v-if="error && !showModal" show variant="danger">
          {{ error.description }}
        </b-alert>
        <br />
        <h2>{{ $t("choose_external_service_for_connect") }}</h2>
        <br />
        <div>
          <div>
            <br />
            <label for="object-input-with-list">{{
              $t("choose_product")
            }}</label>
            <v-select
              v-model="product"
              :options="products"
              label="name"
              code="id"
            ></v-select>
          </div>
          <div v-if="product">
            <br />
            <b-card-group deck>
              <!-- <b-card
                :img-src="require(`../assets/nest.png`)"
                img-alt="Google Nest"
                tag="article"
                class="mb-4"
              >
                <b-button
                  size="lg"
                  block
                  target="_blank"
                  :href="`https://nestservices.google.com/partnerconnections/${nest.project_id}/auth?redirect_uri=${nest.redirect_uri[product.name]}&client_id=${nest.client_id}&access_type=offline&prompt=consent&response_type=code&scope=${nest.scope}`"
                  variant="primary"
                  >{{ $t("oauth_service_connect") }}</b-button
                >

                <template slot="footer">
                  <b-button block to="/oauth/i3pro/nest" variant="light">{{
                    $t("oauth_tokens_btn")
                  }}</b-button>
                </template>
              </b-card> -->
              <b-card
                :img-src="require(`../assets/legrand.png`)"
                img-alt="Legrand"
                tag="article"
                class="mb-4"
              >
                <b-button
                  block
                  size="lg"
                  target="_blank"
                  :href="`https://partners-login.eliotbylegrand.com/authorize?client_id=${legrand.client_id}&response_type=code&state=${legrand.state}&redirect_uri=${legrand.redirect_uri[product.name]}`"
                  variant="primary"
                  >{{ $t("oauth_service_connect") }}</b-button
                >

                <template slot="footer">
                  <b-button block :to="`/oauth/${product.name}/legrand`" variant="light">{{
                    $t("oauth_tokens_btn")
                  }}</b-button>
                </template>
              </b-card>
              <b-card
                :img-src="require(`../assets/ajax.png`)"
                img-alt="AJAX"
                tag="article"
                class="mb-4"
              >
                <b-button
                  block
                  size="lg"
                  :to="`/oauth2screen/authorize?service=${ajax.service}&client_id=${ajax.client_id}&response_type=code&state=${ajax.state}&redirect_uri=${ajax.redirect_uri[product.name]}`"
                  variant="primary"
                  >{{ $t("oauth_service_connect") }}</b-button
                >

                <template slot="footer">
                  <b-button block :to="`/oauth/${product.name}/ajax`" variant="light">{{
                    $t("oauth_tokens_btn")
                  }}</b-button>
                </template>
              </b-card>
            </b-card-group>
            <b-card-group deck>
              <b-card
                :img-src="require(`../assets/yeelight.png`)"
                img-alt="Yeelight"
                tag="article"
                class="mb-4"
                style="max-width: calc(50% - 30px);"
              >
                <v-select
                  v-model="yeelight_type"
                  :options="yeelight_types"
                  :clearable="false"
                ></v-select>
                <br />
                <template v-if="yeelight_type=='yeelight'">
                  <b-button
                    block
                    size="lg"
                    target="_blank"
                    :href="`https://account.xiaomi.com/oauth2/authorize?skip_confirm=false&client_id=${yeelight.client_id}&response_type=${yeelight.response_type}&state=${yeelight.state}&redirect_uri=${yeelight.redirect_uri[product.name]}`"
                    variant="primary"
                    >{{ $t("oauth_service_connect") }}</b-button
                  >

                  <template slot="footer">
                    <b-button block :to="`/oauth/${product.name}/yeelight`" variant="light">{{
                      $t("oauth_tokens_btn")
                    }}</b-button>
                  </template>
                </template>
                <template v-if="yeelight_type=='yeelight_pro'">
                  <b-button
                    block
                    size="lg"
                    target="_blank"
                    :href="`https://api-sg.yeelight.com/apis/account/oauth/authorize?skip_confirm=false&client_id=${yeelight_pro.client_id}&response_type=${yeelight_pro.response_type}&state=${yeelight_pro.state}&redirect_uri=${yeelight_pro.redirect_uri[product.name]}`"
                    variant="primary"
                    >{{ $t("oauth_service_connect") }}</b-button
                  >

                  <template slot="footer">
                    <b-button block :to="`/oauth/${product.name}/yeelight_pro`" variant="light">{{
                      $t("oauth_tokens_btn")
                    }}</b-button>
                  </template>
                </template>
              </b-card>

              <b-card
                v-if="showNetatmo"
                :img-src="require(`../assets/netatmo.png`)"
                img-alt="Netatmo"
                tag="article"
                class="mb-4"
                style="max-width: calc(50% - 30px);"
              >
                <b-button
                  block
                  size="lg"
                  href="/services/oauth/i3pro/netatmo"
                  variant="primary"
                  >{{ $t("oauth_service_connect") }}</b-button
                >
                <template slot="footer">
                  <b-button block :to="`/oauth/${product.name}/netatmo`" variant="light">{{
                    $t("oauth_tokens_btn")
                  }}</b-button>
                </template>
              </b-card>
              <b-card
                v-else-if="curUser && curUser.email === 'gold@iridiummobile.net'"
                :img-src="require(`../assets/netatmo.png`)"
                img-alt="Netatmo"
                tag="article"
                class="mb-4"
                style="max-width: calc(50% - 30px);"
              >
                <b-button
                  block
                  size="lg"
                  href="/services/oauth/i3pro/netatmo"
                  variant="primary"
                  >{{ $t("oauth_service_connect") }}</b-button
                >
                <template slot="footer">
                  <b-button block :to="`/oauth/${product.name}/netatmo`" variant="light">{{
                    $t("oauth_tokens_btn")
                  }}</b-button>
                </template>
              </b-card>
            </b-card-group>
          </div>
        </div>

        <br />
      </b-col>
    </b-row>

    <b-col v-if="loading" class="text-center mt-4">
      <b-spinner type="grow" :label="$t('loading')"></b-spinner>
    </b-col>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-alert */

import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'
import api from '../api'
import Auth from '../components/Auth.vue'
import helper from '../../helper'

// console.log('hosts', helper.hosts)

export default {
  components: {
    Auth,
    'v-select': vSelect,
  },
  data() {
    return {
      legrand: {
        service: 'legrand',
        client_id: '2131f1b9-1d09-4ac8-a679-c558b13c490f',
        state: 'd8cdccaa-0c37-4493-ab37-d5d92bc99cd7',
        redirect_uri: {
          i3pro: 'https%3A%2F%2Fcws.iridi.com%2Fservices%2Foauth%2Fi3pro%2Flegrand',
        },
      },
      ajax: {
        client_id: 'ajax',
        service: 'ajax',
        state: 'c558b13c490f-4ac8-a679-2131f1b9-1d09',
        redirect_uri: {
          i3pro: '%2Foauth%2Fi3pro%2Fajax',
        },
      },
      nest: {
        service: 'nest',
        project_id: '10df4bc7-3ccc-4102-8247-4a790a8a9c83',
        client_id:
          '961781343572-ueddmpv6g8s59pbbed0qkp97livijuqj.apps.googleusercontent.com',
        redirect_uri: {
          i3pro: 'https%3A%2F%2Fcws.iridi.com%2Fservices%2Foauth%2Fi3pro%2Fnest',
        },
        scope: 'https://www.googleapis.com/auth/sdm.service',
      },
      yeelight: {
        service: 'yeelight',
        client_id: '2882303761518263720',
        response_type: 'code',
        state: 'pijr4ipjfredflnkt5g',
        redirect_uri: {
          i3pro: 'https%3A%2F%2Fopen-cn.yeelight.com%2Foauth%2Fcallback%2Fe109d2e1-589b-43be-80cd-80fa06281b07',
        },
      },
      yeelight_pro: {
        service: 'yeelight_pro',
        client_id: 'iRidiFP',
        response_type: 'code',
        state: 'pijr4ipjfredflnkt5gd',
        redirect_uri: {
          i3pro: 'https://cws.iridi.com/services/oauth/i3pro/yeelight_pro',
        },
      },
      netatmo: {
        service: 'netatmo',
        client_id: '6a58cd34bd141ddaac0a6778',
        // scope: 'read_station read_thermostat write_thermostat read_magellan read_smarther read_bubendorff read_mhs1 write_magellan write_smarther write_bubendorff',
        scope: 'read_station read_smarther read_bubendorff read_thermostat write_thermostat read_magellan write_magellan write_smarther write_bubendorff',
        state: 'pijr4ipjfredfln5gd',
        redirect_uri: {
          i3pro: 'https://cws.iridi.com/services/oauth/i3pro/netatmo',
        },
      },
      yeelight_type: 'yeelight',
      yeelight_types: ['yeelight', 'yeelight_pro'],
      error: null,
      loading: false,
      projectsLoading: false,
      service: null,
      objects: [],
      choosedObject: null,
      serviceParams: null,
      token: '',
      extObjectTokens: [],
      curUser: null,
      showModal: false,
      deviceParams: {
        device_name: '',
        custom_data: '',
      },
      product: null,
      products: [
        // { name: 'i3knx', code: 'i3knx' },
        // { name: 'i3lite', code: 'i3lite' },
        { name: 'i3pro', code: 'i3pro_bx' },
      ],
      showTokenInfoModal: false,
      tokenServiceInfo: null,
    }
  },
  computed: {
    extObjectTokenFields() {
      return [
        {
          key: 'device_meta.device_name',
          label: this.$t('device'),
        },
        {
          key: 'createdAt',
          label: this.$t('created_at'),
        },
        {
          key: 'actions',
          label: '', // this.$t('actions'),
        },
      ]
    },
    modalTitle() {
      return {
        objectName: this.choosedObject ? this.choosedObject.name : '',
        service: this.$t(`cws_${this.service}`),
      }
    },
    productApiUrl() {
      return this.product && this.region
        ? `${this.region.hosts[this.product.code]}/api/front/protected`
        : null
    },
    region() {
      return this.$root.$data.state.choosedRegion
    },
    isAuthInCurrentRegion() {
      return (
        this.region
        && this.$root.$data.state.auth
        && this.$root.$data.state.auth.token
        && this.$root.$data.state.auth.expTokenJsTimestamp > Date.now()
      )
    },
    showNetatmo() {
      return this.curUser
      && (this.curUser.email === 'charles.lai@i2.com.tw'
        || this.curUser.email === 'fuji.wang@i2.com.tw'
        || this.curUser.email === 'pierre.huang@i2.com.tw'
        || this.curUser.email === 'ds@fti.com.tw'
        || this.curUser.email === 'andy.hung@fti.com.tw')
    },
  },
  watch: {
    showModal() {
      this.error = null
    },
    showTokenInfoModal(val) {
      this.error = null
      if (val === false) {
        this.tokenServiceInfo = null
      }
    },
    product: {
      deep: true,
      handler(val) {
        this.error = null
        console.log('product is changed', val)
        this.choosedObject = null
        this.extObjectTokens = []
        if (this.isAuthInCurrentRegion) {
          this.getObjects()
          this.getUserInfo()
        }
      },
    },
    isAuthInCurrentRegion(isSuccessAuth) {
      if (isSuccessAuth) {
        this.getObjects()
        this.getUserInfo()
      }
    },
    choosedObject: {
      deep: true,
      handler() {
        if (this.isAuthInCurrentRegion) {
          this.getTokens()
        }
      },
    },
  },
  methods: {
    handleError(response, code) {
      if (code === 200) {
        this.error = response
      } else if (response && response.status !== 500) {
        this.error = response.data.error
      } else {
        this.error = {
          type: this.$t('server_error'),
          description: this.$t('try_again_later'),
        }
      }
    },
    async getObjects() {
      if (!this.productApiUrl) {
        console.log('productApiUrl undefinded')
        return
      }

      if (!this.product) {
        return
      }

      this.projectsLoading = true

      const hosts = helper.hosts.filter((r) => r.available)
      const uniq = {}

      // eslint-disable-next-line no-restricted-syntax
      for (const region of hosts) {
        try {
          const res = await api.withAuth.get(
            `${
              region.hosts[this.product.code]
            }/api/front/protected/user/objects`,
          )
          res.data.data.forEach((obj) => {
            uniq[`${obj.id}:${region.code}`] = {
              crossId: `${region.code}:${obj.id}`,
              objectId: obj.id,
              objectUid: obj._id,
              region: {
                name: region.name,
                code: region.code,
              },
              name:
                hosts.length > 1 ? `${obj.name} [${region.code}]` : obj.name,
              product: this.product,
            }
          })
        } catch ({ response }) {
          this.handleError(response)
        }
      }

      this.objects = Object.values(uniq)
      this.projectsLoading = false
    },
    getTokens() {
      if (!this.choosedObject) {
        return
      }
      if (!this.productApiUrl) {
        return
      }

      this.loading = true

      api.withAuth
        .get(
          `${this.productApiUrl}/user/object/${
            this.choosedObject.objectId
          }/cws/tokens${this.service ? `?service=${this.service}` : ''}`,
        )
        .then((res) => res.data)
        .then((res) => {
          console.log('res', res)
          this.extObjectTokens = res.data.length
            ? res.data
              .filter((t) => t.active)
              .map((t) => {
                t.createdAt = t.created_at ? t.created_at : t.createdAt

                if (!t.device_meta) {
                  t.device_meta = {
                    device_name: this.$t('device_name_not_used'),
                    custom_data: '',
                  }
                }

                return t
              })
              .map((t) => {
                t.createdAt = t.createdAt
                  ? new Date(t.createdAt).toLocaleString()
                  : this.$t('created_undefined')
                return t
              })
            : []
        })
        .catch(({ response }) => {
          this.handleError(response)
        })
        .finally(() => {
          this.loading = false
        })
    },
    linkOAuth(e) {
      e.preventDefault()
      if (!this.productApiUrl) {
        return
      }
      if (!this.service) {
        this.error = 'undefined linked sevice undefined'
        return
      }
      this.error = null
      this.loading = true

      api.withAuth
        .post(`${this.productApiUrl}/user/services/${this.service}/oauth`, {
          oid: this.choosedObject.objectId,
          serviceParams: this.serviceParams,
          deviceParams: this.deviceParams,
          product: this.product,
          region: this.region,
          lang: this.$i18n.locale,
          scope: this.serviceParams.scope,
          code: this.serviceParams.code,
        })
        .then((res) => res.data)
        .then((res) => {
          if (res.error) {
            this.handleError(res.error, 200)
          }

          if (res.data.access_token) {
            this.getTokens()
          }

          // "access_token": "access-token",
          // "expires_in": 3599,
          // "refresh_token": "refresh-token",
          // "scope": "https://www.googleapis.com/auth/sdm.service",
          // "token_type": "Bearer"

          // if (res.data.authLink) {
          //   window.location.href = res.data.authLink
          // }
          // // legacy from bx core
          // if (res.data.auth_link) {
          //   // console.log(res.data.auth_link)
          //   window.location.href = res.data.auth_link
          // }
        })
        .catch(({ response }) => {
          this.handleError(response)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getTokenInfo(token) {
      if (!token) {
        this.error = 'undefined token'
      }

      api.cwsBack
        .post(
          'https://cws.iridi.com/api/google/nest/command/get',
          { path: 'devices' },
          { headers: { Authorization: `Bearer ${token.token}` } },
        )
        .then((res) => {
          if (res.data.data) {
            this.showTokenInfoModal = true
            this.tokenServiceInfo = JSON.stringify(res.data.data, undefined, 2)
          }
          /// console.log('res', res)
        })
        .catch(({ response }) => {
          this.handleError(response)
        })
        .finally(() => {
          this.loading = false
        })
    },
    unlinkToken(token) {
      if (!this.productApiUrl) {
        return
      }
      if (!token) {
        this.error = 'undefined token'
        return
      }

      const ok = () => {
        this.loading = true

        api.withAuth
          .post(`${this.productApiUrl}/user/services/${this.service}/unlink`, {
            token,
            oid: this.choosedObject.objectId,
            lang: this.$i18n.locale,
          })
          .then(() => {
            this.getTokens()
          })
          .catch(({ response }) => {
            this.handleError(response)
          })
          .finally(() => {
            this.loading = false
          })
      }

      this.$confirm.show(this.$t('are_you_sure_to_unlink'), ok)

      // eslint-disable-next-line no-restricted-globals
      // if (confirm(this.$t('are_you_sure_to_unlink'), ok)) {
      //   ok()
      // }
    },
    async getUserInfo() {
      try {
        const res = await api.withAuth.get(`${this.region.hosts.auth_api}/api/front/protected/user/info`)

        this.curUser = res.data.data
      } catch ({ response }) {
        this.handleError(response)
      }
    },
  },
  mounted() {
    this.serviceParams = this.$route.query
    this.service = this.$route.params.externalService

    if (this.token) {
      this.getObjects()
      this.getUserInfo()
    }

    if (this.$route.params.product) {
      this.product = this.products.find(
        (p) => p.name === this.$route.params.product,
      )
    } else {
      this.product = this.products[0]
    }

    // if (this.products.length === 1) {
    //   this.product = this.products[0]
    // }
  },
}
</script>

<style>
  .card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
  }
  .card-img {
    max-width: 268px;
    margin: 0 auto;
  }
  .card-body .v-select{
    align-self: stretch;
  }
</style>
